export const addCompensation = '/compensation';
export const addOfferLetter = '/offerLetter';
